module.exports = __webpack_public_path__ + "static/media/logo.7de013f4.svg";